// src/hooks/useReveal.js
import { useEffect, useRef, useState } from "react";

/**
 * useReveal - returns [ref, visible]
 * Adds a small IntersectionObserver to toggle visible class.
 * options: { threshold, rootMargin }
 */
export default function useReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const node = ref.current;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            // once visible we can unobserve
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: options.threshold ?? 0.2,
        rootMargin: options.rootMargin ?? "0px",
      }
    );

    obs.observe(node);
    return () => obs.disconnect();
  }, [ref, options.threshold, options.rootMargin]);

  return [ref, visible];
}
